import { render, staticRenderFns } from "./MediaField.vue?vue&type=template&id=5b6340c8"
import script from "./MediaField.vue?vue&type=script&lang=js"
export * from "./MediaField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports